<template>
    <div class="band-gallery__container col-md-4">
        <div class="band-gallery align-self-stretch" @click="openGallery()">
            <div class="band-gallery__thumbnail-container" v-bind:style="{ 'background-image': 'url(' + thumbnailImage + ')' }">
                <div class="band-gallery__overlay"></div>
            </div>
            <div class="band-gallery__title">{{ name }}</div>
        </div>
        <!-- Root element of PhotoSwipe. Must have class pswp. -->
        <div ref="photoswipe" class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

            <!-- Background of PhotoSwipe.
                 It's a separate element as animating opacity is faster than rgba(). -->
            <div class="pswp__bg"></div>

            <!-- Slides wrapper with overflow:hidden. -->
            <div class="pswp__scroll-wrap">

                <!-- Container that holds slides.
                    PhotoSwipe keeps only 3 of them in the DOM to save memory.
                    Don't modify these 3 pswp__item elements, data is added later on. -->
                <div class="pswp__container">
                    <div class="pswp__item"></div>
                    <div class="pswp__item"></div>
                    <div class="pswp__item"></div>
                </div>

                <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
                <div class="pswp__ui pswp__ui--hidden">

                    <div class="pswp__top-bar">

                        <!--  Controls are self-explanatory. Order can be changed. -->

                        <div class="pswp__counter"></div>

                        <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                        <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                        <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

                        <!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR -->
                        <!-- element will get class pswp__preloader--active when preloader is running -->
                        <div class="pswp__preloader">
                            <div class="pswp__preloader__icn">
                                <div class="pswp__preloader__cut">
                                    <div class="pswp__preloader__donut"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                        <div class="pswp__share-tooltip"></div>
                    </div>

                    <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
                    </button>

                    <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
                    </button>

                    <div class="pswp__caption">
                        <div class="pswp__caption__center"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PhotoSwipe from 'photoswipe';
    import PhotoSwipeDefaults from 'photoswipe/src/js/ui/photoswipe-ui-default';

    export default {
        props: {
            images: {
                required: true,
                type: Array
            },
            name: {
                required: true,
                type: String
            },
            thumbnailImage: {
                required: true,
                type: String,
            }
        },
        data() {
            return {
                photoSwipeInstance: null,
            };
        },
        methods: {
            /**
             * Resolves the given image urls in the props and produces an array of photoSwipe compilant objects:
             * {
             *   h: imageHeight,
             *   w: imageWidth,
             *   src: imageSrc
             *  }
             *
             * @returns {Promise<Array>}
             */
            resolveImageDimensions() {
                return new Promise((resolveImages) => {
                    let photoswipeImages = [];
                    let imagePromises = [];

                    this.images.forEach((imageSource) => {
                        imagePromises.push(new Promise((resolveImage, reject) => {
                            let image = new Image();
                            image.onload = () => {
                                return resolveImage(image);
                            };
                            image.onerror = () => {
                                reject(new Error(`Image ${imageSource} not found.`));
                            };
                            image.src = imageSource;
                        }).then((image) => {
                            return photoswipeImages.push({
                                h: image.naturalHeight,
                                w: image.naturalWidth,
                                src: image.src
                            });
                        }));
                    });
                    Promise.all(imagePromises).then(() => {
                        return resolveImages(photoswipeImages);
                    }).catch((error) => {
                        console.log(error.message);
                        return resolveImages(photoswipeImages);
                    });
                });
            },
            openGallery() {
                this.resolveImageDimensions().then((items) => {
                    if (items.length !== 0) {
                        this.photoSwipeInstance = new PhotoSwipe(this.$refs.photoswipe, PhotoSwipeDefaults, items, {
                            index: 0
                        });
                        this.photoSwipeInstance.init();
                    }
                    this.$ga.event('Band gallery', 'Opened');
                    gtag('event', 'view_band_gallery', { gallery_name: this.name });
                });
            }
        },
    };
</script>
